<template>
    <div class="bg-white shadow-md rounded-xl p-4 m-4">
        <MonkeyLoader v-if="isLoading" />
        <h2 class="text-xl font-semibold mb-6 text-gray-800 border-b pb-2">Update Template Document GR</h2>

        <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="select-customer">
                Pilih Customer
            </label>
            <select id="select-customer" v-model="selectedCustomerId"
                class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                <option :value="null" disabled>-- Pilih customer terlebih dahulu --</option>
                <option v-for="cust in customerList" :key="cust.id" :value="cust.id">
                    {{ cust.name }}
                </option>
            </select>
        </div>

        <div class="mb-6" v-if="selectedCustomerId">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="select-template">
                Pilih Template untuk Diperbarui
            </label>
            <select id="select-template" v-model="selectedFileId"
                class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
                <option :value="null" disabled>-- Pilih dari template yang dimiliki customer ini --</option>
                <option v-for="template in customerTemplates" :key="template.fileId" :value="template.fileId">
                    {{ template.description }}
                </option>
            </select>
        </div>

        <fieldset :disabled="!selectedFileId" class="transition-opacity duration-300"
            :class="{ 'opacity-50 cursor-not-allowed': !selectedFileId }">
            <form @submit.prevent="saveTemplate">
                <div class="grid grid-cols-1 gap-4">
                    <div class="form-section">
                        <div class="mb-4">
                            <label class="block text-gray-700 text-sm font-bold mb-2" for="categoryCompany">Category
                                Company</label>
                            <div class="flex items-center space-x-2">
                                <select id="categoryCompany" v-model="form.categoryCompanyId"
                                    @blur="validateField('categoryCompanyId')"
                                    class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700">
                                    <option disabled value="">-- Pilih Kategori --</option>
                                    <option v-for="cat in options.categories" :key="cat.id" :value="cat.id">{{ cat.name
                                    }}
                                    </option>
                                </select>
                                <button @click.prevent="openModal('category')" type="button" class="button-add">
                                    <PlusIcon class="h-5 w-5" />
                                </button>
                            </div>
                            <p v-if="!valid.categoryCompanyId" class="text-red-500 text-xs italic mt-1">{{
                                validationMessages.categoryCompanyId }}</p>
                        </div>
                        <div class="mb-4">
                            <label class="block text-gray-700 text-sm font-bold mb-2" for="typePo">Type PO</label>
                            <div class="flex items-center space-x-2">
                                <select id="typePo" v-model="form.typePoId" @blur="validateField('typePoId')"
                                    class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700">
                                    <option disabled value="">-- Pilih Tipe PO --</option>
                                    <option v-for="type in options.poTypes" :key="type.id" :value="type.id">{{
                                        type.name }}
                                    </option>
                                </select>
                                <button @click.prevent="openModal('poType')" type="button" class="button-add">
                                    <PlusIcon class="h-5 w-5" />
                                </button>
                            </div>
                            <p v-if="!valid.typePoId" class="text-red-500 text-xs italic mt-1">{{
                                validationMessages.typePoId }}</p>
                        </div>
                        <div class="mb-4">
                            <label class="block text-gray-700 text-sm font-bold mb-2"
                                for="templateName">Template</label>
                            <div class="flex items-center space-x-2">
                                <select id="templateName" v-model="form.templateId" @blur="validateField('templateId')"
                                    class="input-border shadow appearance-none border rounded w-full py-2 px-3 text-gray-700">
                                    <option disabled value="">-- Pilih Template --</option>
                                    <option v-for="temp in options.templates" :key="temp.id" :value="temp.id">{{
                                        temp.name
                                    }}</option>
                                </select>
                                <button @click.prevent="openModal('template')" type="button" class="button-add">
                                    <PlusIcon class="h-5 w-5" />
                                </button>
                            </div>
                            <p v-if="!valid.templateId" class="text-red-500 text-xs italic mt-1">{{
                                validationMessages.templateId }}</p>
                        </div>
                        <div class="mb-4">
                            <label class="block text-gray-700 text-sm font-bold mb-2">Document Checklist</label>
                            <div class="bg-gray-50 p-4 rounded-lg border max-h-80 overflow-y-auto">
                                <div class="grid grid-cols-2 sm:grid-cols-3 gap-4">
                                    <div v-for="(checked, name) in form.checklist" :key="name">
                                        <label class="flex items-center space-x-3 cursor-pointer">
                                            <input type="checkbox" v-model="form.checklist[name]"
                                                class="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500">
                                            <span class="text-gray-700 text-sm">{{ name }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <p v-if="!valid.checklist" class="text-red-500 text-xs italic mt-1">{{
                                validationMessages.checklist }}</p>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center mt-6 pt-4 border-t">
                    <button type="submit" :disabled="!isFormValid"
                        class="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-bold py-2 px-8 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mr-4 transition-all transform hover:scale-105">
                        Update
                    </button>
                    <button type="button" @click="cancel"
                        class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-8 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-transform transform hover:scale-105">
                        Cancel
                    </button>
                </div>
            </form>
        </fieldset>

        <AddModal :show="modal.visible" :title="modal.title" :label="modal.label" @close="closeModal"
            @save="handleSaveFromModal" />
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { PlusIcon } from '@heroicons/vue/24/solid';
import AddModal from './AddModal.vue';
import MonkeyLoader from '../Layout/MonkeyLoader.vue';

const API_BASE_URL = window.location.origin;
const API_ENDPOINTS = {
    categories: `${API_BASE_URL}/api/companycategory`,
    poTypes: `${API_BASE_URL}/api/potype`,
    templates: `${API_BASE_URL}/api/potemplate`,
    documentFiles: `${API_BASE_URL}/api/documentfiles`,
    groupedDocuments: `${API_BASE_URL}/api/documents`
};

const getInitialFormData = () => ({
    categoryCompanyId: '',
    typePoId: '',
    templateId: '',
    checklist: {
        'PO': false, 'DN': false, 'MRA': false, 'BA': false, 'MOS': false, 'BALAP': false, 'ATP': false,
        'Tes Comm (L1 S/d L3)': false, 'Tes Comm (L1 S/d L5)': false, 'BAUT': false, 'BABT': false,
        'BAST': false, 'ESAR': false, 'GR Number': false, 'ABD(AS Build Drawing)': false,
        'Factory QC certificate/pass': false, 'Warranty Certificate': false,
    }
});

export default {
    name: 'DocumentGrTemplateUpdate',
    components: { PlusIcon, AddModal, MonkeyLoader },
    data() {
        return {
            selectableTemplates: [],
            selectedCustomerId: null,
            selectedFileId: null,
            form: getInitialFormData(),
            options: {
                categories: [],
                customers: [],
                poTypes: [],
                templates: [],
            },
            valid: { categoryCompanyId: true, typePoId: true, templateId: true, checklist: true },
            validationMessages: { categoryCompanyId: '', typePoId: '', templateId: '', checklist: '' },
            isFormValid: false,
            modal: { visible: false, title: '', label: '', type: '', existingItems: [], nameKey: 'name' }
        };
    },
    computed: {
        customerList() {
            if (!this.selectableTemplates.length) return [];
            const customerMap = new Map();
            this.selectableTemplates.forEach(template => {
                if (!customerMap.has(template.custId)) {
                    customerMap.set(template.custId, {
                        id: template.custId,
                        name: template.custName
                    });
                }
            });
            return Array.from(customerMap.values()).sort((a, b) => a.name.localeCompare(b.name));
        },
        customerTemplates() {
            if (!this.selectedCustomerId) return [];
            return this.selectableTemplates.filter(template => template.custId === this.selectedCustomerId);
        }
    },
    methods: {
        async loadSelectableTemplates() {
            try {
                const response = await axios.get(API_ENDPOINTS.groupedDocuments);
                this.selectableTemplates = response.data;
            } catch (error) {
                console.error('Gagal memuat daftar template:', error);
                Swal.fire('Error', 'Gagal memuat daftar template yang sudah ada.', 'error');
            }
        },
        async loadTemplateDetails(id) {
            if (!id) {
                this.resetFormFields();
                return;
            }
            try {
                const response = await axios.get(`${API_ENDPOINTS.documentFiles}/${id}`);
                const data = response.data;
                this.form.categoryCompanyId = data.categoryid;
                this.form.typePoId = data.potypeid;
                this.form.templateId = data.potemplateid;
                Object.keys(this.form.checklist).forEach(key => this.form.checklist[key] = false);
                if (data.documentdetails && Array.isArray(data.documentdetails)) {
                    data.documentdetails.forEach(detail => {
                        if (Object.hasOwn(this.form.checklist, detail.docname))
                            this.form.checklist[detail.docname] = true;
                    });
                }
                this.$nextTick(() => {
                    Object.keys(this.valid).forEach(field => this.validateField(field));
                });
            } catch (error) {
                console.error(`Gagal memuat detail template ID ${id}:`, error);
                Swal.fire('Error', 'Gagal memuat detail template yang dipilih.', 'error');
                this.resetFormFields();
            }
        },
        async loadFormOptions() {
            this.fetchData(API_ENDPOINTS.categories, 'categories', item => ({ id: item.id, name: item.category }));
            this.fetchData(API_ENDPOINTS.poTypes, 'poTypes', item => ({ id: item.id, name: item.typename }));
            this.fetchData(API_ENDPOINTS.templates, 'templates', item => ({ id: item.id, name: item.templatename }));
        },
        async fetchData(url, targetState, mapper) {
            try {
                const response = await axios.get(url);
                this.options[targetState] = Array.isArray(response.data) ? response.data.map(mapper) : [];
            } catch (error) {
                console.error(`Error fetching ${targetState}:`, error);
                this.options[targetState] = [];
            }
        },
        async saveTemplate() {
            Object.keys(this.valid).forEach(field => this.validateField(field));
            if (!this.isFormValid) {
                Swal.fire('Data Tidak Lengkap', 'Harap isi semua field yang wajib diisi.', 'warning');
                return;
            }
            const selectedCustomer = this.customerList.find(c => c.id === this.selectedCustomerId);
            const customerName = selectedCustomer ? selectedCustomer.name : '';
            const details = Object.entries(this.form.checklist)
                .filter(([, isChecked]) => isChecked)
                .map(([name]) => ({ docname: name }));
            const payload = {
                categoryid: this.form.categoryCompanyId,
                potypeid: this.form.typePoId,
                potemplateid: this.form.templateId,
                custid: this.selectedCustomerId,
                custname: customerName,
                documentdetails: details
            };
            try {
                await axios.put(`${API_ENDPOINTS.documentFiles}/${this.selectedFileId}`, payload);
                Swal.fire('Berhasil!', 'Data dokumen berhasil diperbarui.', 'success');
                this.cancel();
                this.loadSelectableTemplates();
            } catch (error) {
                console.error('Gagal memperbarui dokumen:', error);
                Swal.fire('Gagal', 'Terjadi kesalahan saat memperbarui data.', 'error');
            }
        },
        resetFormFields() {
            this.form = getInitialFormData();
            Object.keys(this.valid).forEach(field => {
                this.valid[field] = true;
                this.validationMessages[field] = '';
            });
            this.updateFormValidity();
        },
        cancel() {
            this.selectedCustomerId = null;
        },
        validateField(fieldName) {
            this.valid[fieldName] = true;
            this.validationMessages[fieldName] = '';
            let isValid = true;
            switch (fieldName) {
                case 'categoryCompanyId':
                case 'typePoId':
                case 'templateId':
                    if (!this.form[fieldName]) {
                        this.validationMessages[fieldName] = 'This field is required.';
                        isValid = false;
                    }
                    break;
                case 'checklist': {
                    const isAnyChecked = Object.values(this.form.checklist).some(val => val === true);
                    if (!isAnyChecked) {
                        this.validationMessages.checklist = 'At least one document must be checked.';
                        isValid = false;
                    }
                    break;
                }
            }
            this.valid[fieldName] = isValid;
            this.updateFormValidity();
        },
        updateFormValidity() {
            if (!this.selectedFileId) {
                this.isFormValid = false;
                return;
            }
            this.isFormValid = Object.values(this.valid).every(v => v);
        },

        // --- KODE FUNGSI MODAL YANG DIPERBAIKI ---
        openModal(type) {
            this.modal.type = type;
            switch (type) {
                case 'category':
                    this.modal.title = 'Add New Category';
                    this.modal.label = 'Category Name';
                    this.modal.existingItems = this.options.categories;
                    break;
                case 'poType':
                    this.modal.title = 'Add New PO Type';
                    this.modal.label = 'PO Type Name';
                    this.modal.existingItems = this.options.poTypes;
                    break;
                case 'template':
                    this.modal.title = 'Add New Template';
                    this.modal.label = 'Template Name';
                    this.modal.existingItems = this.options.templates;
                    break;
            }
            this.modal.visible = true;
        },
        closeModal() {
            this.modal.visible = false;
        },
        async handleSaveFromModal(newValue) {
            let endpoint = '';
            let payload = {};
            switch (this.modal.type) {
                case 'category':
                    endpoint = API_ENDPOINTS.categories;
                    payload = { category: newValue };
                    break;
                case 'poType':
                    endpoint = API_ENDPOINTS.poTypes;
                    payload = { typename: newValue };
                    break;
                case 'template':
                    endpoint = API_ENDPOINTS.templates;
                    payload = { templatename: newValue };
                    break;
            }
            try {
                const response = await axios.post(endpoint, payload);
                const newItem = response.data;
                this.loadFormOptions(); // Muat ulang semua dropdown
                if (this.modal.type === 'category') this.form.categoryCompanyId = newItem.id;
                if (this.modal.type === 'poType') this.form.typePoId = newItem.id;
                if (this.modal.type === 'template') this.form.templateId = newItem.id;
            } catch (error) {
                console.error(`Gagal menyimpan ${this.modal.type}:`, error);
                Swal.fire('Gagal', `Gagal menyimpan ${this.modal.label} baru.`, 'error');
            } finally {
                this.closeModal();
            }
        }
    },
    watch: {
        selectedCustomerId() {
            this.selectedFileId = null;
            this.resetFormFields();
        },
        selectedFileId(newId) {
            this.loadTemplateDetails(newId);
        },
        'form.categoryCompanyId'() { this.validateField('categoryCompanyId'); },
        'form.typePoId'() { this.validateField('typePoId'); },
        'form.templateId'() { this.validateField('templateId'); },
        'form.checklist': { handler: function () { this.validateField('checklist'); }, deep: true },
    },
    mounted() {
        this.loadSelectableTemplates();
        this.loadFormOptions();
        this.updateFormValidity();
    }
};
</script>

<style scoped>
/* Style tidak berubah */
.input-border {
    border-bottom: 2px solid #ccc;
    border-radius: 0;
    border-left: none;
    border-right: none;
    border-top: none;
}

.input-border:focus {
    border-bottom-color: #3b82f6;
    box-shadow: none;
}

.form-section {
    display: flex;
    flex-direction: column;
}

.button-add {
    @apply bg-blue-500 hover:bg-blue-600 text-white font-bold p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 flex-shrink-0;
}

fieldset:disabled {
    pointer-events: none;
}
</style>